<app-login-layout class="app-dark-theme">
  <main class="register-carrier-finish container h-100">
    <div class="row h-100 align-items-center">
      <div class="col-12 col-md-7 offset-md-5 col-lg-5 offset-lg-7">
        <form [formGroup]="data">

          <h2 class="text-center">Registration step 2</h2>
          <h4 class="text-center mt-4">
            Current account status pending activation.
            <br />
            You will get an email when your account will be activated.
          </h4>

          <div class="mb-3">
            <mat-form-field>
              <input formControlName="password" type="password" matInput placeholder="New Password"
                (ngModelChange)="formValidator()" />
            </mat-form-field>
          </div>

          <div class="mb-3">
            <mat-form-field>
              <input [errorStateMatcher]="matcher" formControlName="confirmPassword" type="password" matInput
                placeholder="Confirm Password" (ngModelChange)="formValidator()" />
            </mat-form-field>

            <div *ngIf="validPassword">
              Not valid password or they are not the same.
            </div>
          </div>

          <div class="mb-3">
            <button [disabled]="data.invalid" (click)="submit()" class="login__form--button text--upper_case"
              mat-raised-button color="primary">
              Finish
            </button>
          </div>

          <div class="row g-2 mt-2 align-items-center">
            <mat-icon>error_outline</mat-icon>
            <span class="ms-2" textSize="12">Make sure you display 8+ characters, caps, number, sign</span>
          </div>
        </form>
      </div>
    </div>
  </main>
</app-login-layout>